import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateField'
})
export class TranslateFieldPipe implements PipeTransform {

  transform(item: any, field: string): string {
    const lang = $localize.locale.split('-')[0]
    let rtn = ''

    if (item[field + '_' + lang])
      rtn = item[field + '_' + lang]
    else if(item[field])
      rtn = item[field]

    return rtn
  }
}
